import { render, staticRenderFns } from "./SidebarVerticalRoot.vue?vue&type=template&id=3185c5a0&"
import script from "./SidebarVerticalRoot.vue?vue&type=script&lang=js&"
export * from "./SidebarVerticalRoot.vue?vue&type=script&lang=js&"
import style0 from "./SidebarVerticalRoot.vue?vue&type=style&index=0&id=3185c5a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports